import { useSelector } from 'react-redux'
import { selectActiveKambiJurisdiction } from '@core/Areas/KambiClient/Store/selectors'
import { useFeature } from '@core/Utils/hooks/useFeature'

export const useIsBetLoopSportsFeatureActive = () => {
  const activeKambiJurisdiction = useSelector(selectActiveKambiJurisdiction)
  const isBetLoopSportActive = useFeature('bet-loop-sports')

  // TEMP: Disable ALL Bet Loop Sports for South Australian accounts
  if (activeKambiJurisdiction === 'rwwasa') {
    return false
  }

  return isBetLoopSportActive
}
